import {
  ELEMENT_ATTRIBUTE_GROUP,
  ELEMENT_GROUPS
} from '../../../../AppDesigner/Elements';

const fields = {
  group: ELEMENT_GROUPS.TEXT,
  name: 'BigCalendar',
  label: 'Big Scheduling Calendar',
  icon: 'DocumentTextIcon',
  description: 'A big calendar',
  properties: [
    {
      label: 'Data Path',
      name: 'dataPath',
      editor: 'textbox',
      readonly: false,
      description: `Enter a string that represents an object page on the page data object, that will be supplied to this chart. The object should contain an array of events in the format { id: 1,
    title: 'Long Event',
    start: new Date(2015, 3, 7),
    end: new Date(2015, 3, 10),}.`,
      options: [],
      function: {
        name: '',
        params: []
      },
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Event Selected Action Sequence Id',
      name: 'onEventSelectedActionSequenceId',
      editor: 'textbox',
      readonly: false,
      description:
        'The ID of an action sequence to run when an event is selected from the calendar.',
      options: [],
      function: {
        name: '',
        params: []
      },
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    }
  ]
};

export default fields;
